[
  { "id": "force", "name": "Force", "description": "+25 Force : dégâts de Terre augmentés.", "stats": { "force": 25 }, "classes": ["sacrieur", "sadida"] },
  { "id": "soif-de-sang", "name": "Soif de sang", "description": "+5 % de vol de vie sur tous les dégâts.", "lifestealPct": 5, "maxStacks": 3, "classes": ["sacrieur"] }
]
